module.exports = __webpack_public_path__ + "static/media/AB_B2_10.0d4f9e15.jpg";